
import Konva from "konva";
import * as ReactKonva from "react-konva";

import packageJson from "../../package.json";


export const getSharedPackages = () => {
  const packages = packageJson.dependencies;

  const reactKonvaVersion = packages["react-konva"];
  const konvaVersion = packages["konva"];
  

  return {
    shared: {
      "react-konva": {
        version: '18.2.10',
        scope: "default",
        lib: () => ReactKonva,
        shareConfig: {
          singleton: true,
          requiredVersion: reactKonvaVersion,
        },
      },
      konva: {
        version: '9.3.0',
        scope: "default",
        lib: () => Konva,
        shareConfig: {
          singleton: true,
          requiredVersion: konvaVersion,
        },
      },
    },
  };
};
